import React from "react";
import Row from "../common/List/Row";
import { getRentStatus } from "../../functions/parking-space";
import { getRentDate } from "../../functions/formatTime";

const ParkingRow = ({ parkingSpace }) => {
  const { number, floor, rented, lease, roomNumber } = parkingSpace;
  const renters = lease?.renters;

  const cellTexts = [
    number,
    floor,
    renters?.length ?? 0,
    renters?.map((renter) => renter.name).join(","),
    roomNumber,
    renters?.map((renter) => renter.phoneNumber ?? "無").join(",") ?? "",
    getRentDate(lease?.startDate, lease?.endDate),
  ];

  const cellAlign = ["C", "C", "C", "C", "C", "C"];

  return (
    <Row
      cellTexts={cellTexts}
      noteTexts={[]}
      showPopUp={() => {}}
      cellAlign={cellAlign}
    />
  );
};

export default ParkingRow;
